
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tentang-kami",
      function () {
        return require("private-next-pages/tentang-kami.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tentang-kami"])
      });
    }
  